module.exports = __webpack_public_path__ + "img/tf.1129c04b.svg";